export const GM_TOOL_GROUPS = [
    {
        key: 'table',
        label: 'Table',
        tools: [
            {
                key: 'command-center',
                label: 'Command Center',
                description: 'Live campaign control, actions and turns',
                icon: 'command-center',
                to: '/game-master',
                exact: true
            },
            {
                key: 'tabletop-map-editor',
                label: 'Map Editor',
                description: 'Build tactical battle maps',
                icon: 'map-editor',
                to: '/game-master/tabletop-map-editor'
            },
            {
                key: 'tabletop-map-player',
                label: 'Map Player',
                description: 'Run the tactical map at the table',
                icon: 'map-player',
                to: '/game-master/tabletop-map-player'
            }
        ]
    },
    {
        key: 'world',
        label: 'World',
        tools: [
            {
                key: 'world-editor',
                label: 'World Editor',
                description: 'Edit positions, regions and connections',
                icon: 'world-editor',
                to: '/game-master/world-editor'
            },
            {
                key: 'world-map',
                label: 'World Map',
                description: 'Global map with game master overlays',
                icon: 'world-map',
                to: '/game-master/world-map'
            },
            {
                key: 'cartograph',
                label: 'Cartograph',
                description: 'Character positions across the continent',
                icon: 'cartograph',
                to: '/game-master/cartograph'
            }
        ]
    },
    {
        key: 'codex',
        label: 'Codex',
        tools: [
            {
                key: 'compendium',
                label: 'Compendium',
                description: 'Skills, items, effects and lore reference',
                icon: 'compendium',
                to: '/game-master/compendium'
            },
            {
                key: 'character-template-editor',
                label: 'Templates',
                description: 'Author NPC and character templates',
                icon: 'templates',
                to: '/game-master/character-template-editor'
            },
            {
                key: 'story-builder',
                label: 'Journal',
                description: 'Story beats and session notes',
                icon: 'journal',
                to: '/game-master/story-builder'
            }
        ]
    },
    {
        key: 'balance',
        label: 'Balance',
        tools: [
            {
                key: 'skill-calculator',
                label: 'Calculator',
                description: 'Cost and power analysis for skills',
                icon: 'calculator',
                to: '/game-master/skill-calculator'
            },
            {
                key: 'skill-impact-visualization',
                label: 'Skill Impact',
                description: 'Visualize damage and effect curves',
                icon: 'impact',
                to: '/game-master/skill-impact-visualization'
            },
            {
                key: 'archetype-comparison',
                label: 'Archetypes',
                description: 'Compare archetype stat profiles',
                icon: 'archetypes',
                to: '/game-master/archetype-comparison'
            }
        ]
    },
    {
        key: 'session',
        label: 'Session',
        tools: [
            {
                key: 'impersonate',
                label: 'Play As',
                description: 'Play as any character in the campaign',
                icon: 'impersonate',
                to: '/game-master/impersonate'
            }
        ]
    }
];

export const GM_TOOLS = GM_TOOL_GROUPS.flatMap(group => group.tools);

export function resolveActiveGmTool(path) {
    const clean = (path || '').replace(/\/+$/, '') || '/';
    let match = null;
    for (const tool of GM_TOOLS) {
        if (tool.exact) {
            if (clean === tool.to) {
                return tool;
            }
            continue;
        }
        if (clean === tool.to || clean.startsWith(`${tool.to}/`)) {
            if (!match || tool.to.length > match.to.length) {
                match = tool;
            }
        }
    }
    return match;
}
